import { useContext, useState, useEffect, React, memo, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Card, Col, Row, Input } from "reactstrap";
import "./RequestSpecialBilling.css";
import * as Constants from "../../../utils/Constants";
import * as DateUtil from "../../../utils/DateUtil";
import "react-tabs/style/react-tabs.css";
import { formDataContext } from "../SpecialBillingPage";
import {
  Search,
  CurrencyExchange,
  KeyboardArrowDown,
  KeyboardArrowRight,
  PhotoCameraOutlined,
} from "@mui/icons-material";
import {
  CustomPagination,
  Dropdown,
  MessageAlert,
  DatePicker,
  ModalComponent,
  Button,
} from "../../../components/Components";
function RequestSpecialBilling() {
  const {
    UserInfoData,
    tradeDiscountDate,
    tradeDiscountPercent,
    selectedSubNo,
    organizeList,
    workerList,
    statusList,
    getBillingDetail,
    getQueueDetail,
    addSpecialBill,
  } = useContext(formDataContext);

  const { t, i18n } = useTranslation();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [pageCount, setPageCount] = useState(0);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [selectedBillingStatus, setSelectedBillingStatus] = useState(null);
  const [startDeleveryDate, setStartDeleveryDate] = useState(
    getDateEven(new Date(new Date().toDateString()), 30, false)
  );
  const [endDeleveryDate, setEndDeleveryDate] = useState(
    getDateEven(new Date(new Date().toDateString()), 0, false)
  );
  const [optionsOrganize, setOptionsOrganize] = useState(null);
  const [optionsWorker, setOptionsWorker] = useState(null);
  const [optionsStatusJob, setOptionsStatusJob] = useState(null);
  const [searchResult, setSearchResult] = useState(null);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [queueDetail, setQueueDetail] = useState(false);
  const [isOpenModalQueueDetail, setIsOpenModalQueueDetail] = useState(false);
  const isTH = i18n.language === Constants.Language.Thai;

  const handleselectGroup = (e) => {
    setSelectedGroup(e);
    setOptionsWorker(filterWorker(e?.value));
  };

  const handleselectWorker = (e) => {
    setSelectedWorker(e);
    setOptionsOrganize(filterGroup(e?.value));
  };

  const handleselectStatus = (e) => {
    setSelectedBillingStatus(e);
  };

  const handleselectStartDeliveryDate = (e) => {
    setStartDeleveryDate(e);
    setEndDeleveryDate(getDateEven(e, 30, true));
  };

  const handleselectEndDeliveryDate = (e) => {
    setEndDeleveryDate(e);
  };

  const onClickRequestSpecialRounds = () => {
    let checkedBill = searchResult?.filter(
      (billing) =>
        billing?.isCheck ||
        (billing?.value?.dropDetailList?.some((drop) => drop?.isCheck))
    );
    let countQueue = checkedBill
      .flatMap((billing) =>
        billing?.value?.dropDetailList
          ?.filter((drop) => drop?.isCheck)
          ?.flatMap((drop) => drop?.queueDetailList?.length)
      )
      .reduce((acc, currentValue) => acc + currentValue, 0);
    let sumIncome = checkedBill
      .flatMap((billing) =>
        billing?.value?.dropDetailList
          ?.filter((drop) => drop?.isCheck)
          ?.flatMap((drop) => drop?.dropIncome)
      )
      .reduce((acc, currentValue) => acc + currentValue, 0);
    let sumDiscount = (sumIncome * tradeDiscountPercent) / 100;
    let sumEstimateIncome = sumIncome - sumDiscount;

    MessageAlert.confirm({
      title: t("ConfirmSpecialBill"),
      html: `
            <table class='tableHeadDialog'>
                <tbody>
                    <tr>
                        <td>
                            <label>${t("ConfirmSpecialBillQueueCount", {
                              queueCount: countQueue,
                            })}</label>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label>${t("DeductibleFee", {
                              tradeDiscountPercent: tradeDiscountPercent,
                            })}</label>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <label>${t("ReceiveMoneyWithin", {
                              tradeDiscountDate: tradeDiscountDate,
                            })}</label>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table class='tableDetailDialog'>
                <tbody>
                    <tr>
                        <td style="width: 70%; text-align: right;">
                            <label style="margin-right: 20px;">${t(
                              "Income"
                            )}</label>
                        </td>
                        <td style="width: 30%; text-align: right;">
                            <label>${sumIncome
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, "$&,")} ${t(
        "Bath"
      )}</label>
                        </td>
                    </tr>
                    <tr class='textRed'>
                        <td style="width: 70%; text-align: right;">
                            <label style="margin-right: 20px;">${t(
                              "DeductProcessingFee",
                              { processingFee: tradeDiscountPercent }
                            )}</label>
                        </td>
                        <td style="width: 30%; text-align: right;">
                            <label>${sumDiscount
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, "$&,")} ${t(
        "Bath"
      )}</label>
                        </td>
                    </tr>
                    <tr class='textGreen'>
                        <td style="width: 70%; text-align: right;">
                            <label style="margin-right: 20px;">${t(
                              "SpecialEstimatedIncome"
                            )}</label>
                        </td>
                        <td style="width: 30%; text-align: right;">
                            <label>${sumEstimateIncome
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, "$&,")} ${t(
        "Bath"
      )}</label>
                        </td>
                    </tr>
                </tbody>
            </table> `,
      hidenIcon: true,
      onConfirm: () => {
        requestSpecialBill(checkedBill);
      },
    });
  };

  const requestSpecialBill = async (checkedBill) => {
    let resultAddBill = await addSpecialBill({
      subNo: selectedSubNo,
      whoAdd: UserInfoData?.chiefNo,
      tmskeyList: checkedBill?.flatMap((billing) =>
        billing?.value?.dropDetailList?.sort((a, b) => (b?.dropIncome - a?.dropIncome))?.sort((a, b) => (b?.dropIncome - a?.dropIncome))
          ?.filter((drop) => drop.isCheck)
          ?.flatMap((drop) =>
            drop?.queueDetailList?.flatMap((queue) => queue.tmsKey)
          )
      ),
    });
    if (resultAddBill) {
      await MessageAlert.success({
        title: t("Warning"),
        html: `
                    <div">
                        <Row className='RowDeatail'>
                            <label>${t("BillingSavedSuccessfully")} </label>
                        </Row>
                        <Row className='RowDeatail'>
                            <label>${t("RequestSequenceADVNo", {
                              ADVNo: resultAddBill?.advNo,
                            })} </label>
                        </Row>
                    </div>`,
        confirmButtonText: t("Confirm"),
      });
      onSearchBilling(pageSize);
    }
  };

  const onClickViewQueueDetail = async (daliveryDate, workerNo, shiptoNo) => {
    let queue = await getQueueDetail({
      deliveryDate: daliveryDate,
      shiptoNo: shiptoNo,
      workerNo: workerNo,
    });

    if (queue) {
      setQueueDetail(queue);
      setIsOpenModalQueueDetail(true);
    }
  };

  const onSearchBilling = async (pageSizeSearch) => {
    try {
      if (!startDeleveryDate || !endDeleveryDate)
        throw new Error(
          t("PleaseSpecifyFormat", { format: t("DeliveryDate") })
        );
      let result = await getBillingDetail({
        deliveryStart:
          DateUtil.ConvertInputDateToISOFormatDateTimeString(startDeleveryDate),
        deliveryEnd:
          DateUtil.ConvertInputDateToISOFormatDateTimeString(endDeleveryDate),
        subno: selectedSubNo,
        organizeID: selectedGroup?.value,
        workno: selectedWorker?.value,
        billingStatus: selectedBillingStatus
          ? selectedBillingStatus?.value
          : Constants.BillingStatus.All,
        startRow: 0,
        pageSize: pageSizeSearch,
      });
      if (result?.billingList && result?.billingList?.length > 0) {
        let tempResult = Array.from(
          { length: result?.totalRecord },
          () => null
        );
        tempResult.splice(
          0,
          result?.billingList?.length,
          ...result?.billingList?.map(function (item) {
            return {
              value: item,
              isExpand: false,
              isCheck: false,
            };
          })
        );
        setSearchResult(tempResult);
        setPageSize(pageSizeSearch);
        setPageCount(Math.ceil((result?.totalRecord ?? 0) / pageSizeSearch));
        setPage(1);
        setIsSelectAll(false);
      } else {
        setSearchResult([]);
      }
    } catch (error) {
      MessageAlert.error({
        title: t("Error"),
        message: error?.message,
      });
    }
  };

  const handlePageChange = async (newPage) => {
    if (
      !searchResult[(newPage - 1) * pageSize] ||
      !searchResult[(newPage - 1) * pageSize]?.value
    ) {
      if (!startDeleveryDate || !endDeleveryDate)
        throw new Error(
          t("PleaseSpecifyFormat", { format: t("DeliveryDate") })
        );
      let result = await getBillingDetail({
        deliveryStart:
          DateUtil.ConvertInputDateToISOFormatDateTimeString(startDeleveryDate),
        deliveryEnd:
          DateUtil.ConvertInputDateToISOFormatDateTimeString(endDeleveryDate),
        subno: selectedSubNo,
        organizeID: selectedGroup?.value,
        workno: selectedWorker?.value,
        billingStatus: selectedBillingStatus
          ? selectedBillingStatus?.value
          : Constants.BillingStatus.All,
        startRow: (newPage - 1) * pageSize,
        pageSize: pageSize,
      });
      const tempResult = searchResult.map((billing, index) =>
        index >= (newPage - 1) * pageSize &&
        index <= (newPage - 1) * pageSize + pageSize - 1
          ? {
              ...billing,
              isCheck: result?.billingList[
                index - (newPage - 1) * pageSize
              ]?.dropDetailList?.some((item) => !item?.billingStatus)
                ? billing?.isCheck
                : false,
              value: {
                ...result?.billingList[index - (newPage - 1) * pageSize],
                dropDetailList: result?.billingList[
                  index - (newPage - 1) * pageSize
                ]?.dropDetailList?.sort((a, b) => (b?.dropIncome - a?.dropIncome))?.map((drop, indDrop) => ({
                  ...drop,
                  isCheck: result?.billingList[
                    index - (newPage - 1) * pageSize
                  ]?.dropDetailList?.sort((a, b) => (b?.dropIncome - a?.dropIncome))?.some((item) => !item?.billingStatus)
                    ? billing?.isCheck
                    : false,
                })),
              },
            }
          : billing
      );
      let billingCheck = tempResult
        ?.slice((newPage - 1) * pageSize, (newPage - 1) * pageSize + pageSize)
        .filter((bill) =>
          bill?.value?.dropDetailList?.sort((a, b) => (b?.dropIncome - a?.dropIncome))?.some((item) => !item?.billingStatus)
        );
      setIsSelectAll(
        billingCheck && billingCheck.length > 0
          ? billingCheck.every((billing) => billing?.isCheck)
          : false
      );
      setSearchResult(tempResult);
    } else {
      let billingCheck = searchResult
        ?.slice((newPage - 1) * pageSize, (newPage - 1) * pageSize + pageSize)
        .filter((bill) =>
          bill?.value?.dropDetailList?.sort((a, b) => (b?.dropIncome - a?.dropIncome))?.some((item) => !item?.billingStatus)
        );
      setIsSelectAll(
        billingCheck && billingCheck.length > 0
          ? billingCheck.every((billing) => billing?.isCheck)
          : false
      );
    }
    setPage(newPage);
  };

  const handleCheckSelectAll = (e) => {
    const startIndex = (page - 1) * pageSize;
    setIsSelectAll(e.target.checked);
    const updatedBilling = searchResult.map((billing, index) =>
      index >= startIndex && index <= startIndex + pageSize - 1
        ? {
            ...billing,
            isCheck: billing?.value?.dropDetailList?.some(
              (item) =>
                (!item.billingStatus &&
                  !item?.queueDetailList?.every(
                    (q) => !Constants.SuccessQueueStatus.includes(q.qstatus)
                  )) ||
                Constants.BillingStatus.Cancel === item.billingStatus
            ) && billing?.value?.totalIncome != 0
              ? e.target.checked
              : false,
            value: billing?.value
              ? {
                  ...billing?.value,
                  dropDetailList: billing?.value?.dropDetailList?.sort((a, b) => (b?.dropIncome - a?.dropIncome))?.map(
                    (drop, indDrop) => ({
                      ...drop,
                      isCheck:
                        (!drop?.billingStatus &&
                          !drop?.queueDetailList?.every(
                            (q) =>
                              !Constants.SuccessQueueStatus.includes(q.qstatus)
                          )) ||
                        Constants.BillingStatus.Cancel === drop?.billingStatus
                          ? e.target.checked
                          : false,
                    })
                  ),
                }
              : billing?.value,
          }
        : billing
    );
    setSearchResult(updatedBilling);
  };

  const handleCheckSelectBilling = (e, index) => {
    const currentIndex = (page - 1) * pageSize + index;
    const updatedBilling = searchResult.map((billing, idx) =>
      idx === currentIndex
        ? {
            ...billing,
            isCheck: e.target.checked,
            value: billing?.value
              ? {
                  ...billing?.value,
                  dropDetailList: billing?.value?.dropDetailList?.sort((a, b) => (b?.dropIncome - a?.dropIncome))?.map(
                    (drop, indDrop) => ({
                      ...drop,
                      isCheck:
                      drop.queueDetailList.every((item) => item?.qstatus === Constants.QueueStatus.Success  && item?.pictureStatus === Constants.Status.Yes) && Number(drop?.dropIncome) !== 0
                          ? e.target.checked
                          : false,
                    })
                  ),
                }
              : billing?.value,
          }
        : billing
    );
    setSearchResult(updatedBilling);
    setIsSelectAll(
      updatedBilling
        ?.slice((page - 1) * pageSize, (page - 1) * pageSize + pageSize)
        ?.filter((bill) =>
          bill?.value?.dropDetailList?.some(
            (item) =>
              (!item.billingStatus &&
                !item?.queueDetailList?.every(
                  (q) => !Constants.SuccessQueueStatus.includes(q.qstatus)
                )) ||
              Constants.BillingStatus.Cancel === item.billingStatus
          )
        )
        ?.every((billing) => billing?.isCheck)
    );
  };

  const handleCheckSelectDrop = (e, indexBill, indexDrop) => {
    const currentIndexBill = (page - 1) * pageSize + indexBill;
    const updatedBilling = searchResult
      ?.map((billing, idx) =>
        idx === currentIndexBill &&
        billing?.value?.dropDetailList?.sort((a, b) => (b?.dropIncome - a?.dropIncome))?.some(
          (drop) =>
            (!drop?.billingStatus &&
              !drop?.queueDetailList?.every(
                (q) => !Constants.SuccessQueueStatus.includes(q.qstatus)
              )) ||
            Constants.BillingStatus.Cancel === drop?.billingStatus
        )
          ? {
              ...billing,
              value: {
                ...billing.value,
                dropDetailList: billing?.value?.dropDetailList?.sort((a, b) => (b?.dropIncome - a?.dropIncome))?.map(
                  (drop, indDrop) =>
                    indDrop === indexDrop
                      ? { ...drop, isCheck: e.target.checked }
                      : drop
                ),
              },
            }
          : billing
      )
      ?.map((billing, idx) =>
        idx === currentIndexBill &&
        billing?.value?.dropDetailList?.sort((a, b) => (b?.dropIncome - a?.dropIncome))?.some(
          (drop) =>
            (!drop?.billingStatus &&
              !drop?.queueDetailList?.every(
                (q) => !Constants.SuccessQueueStatus.includes(q.qstatus)
              )) ||
            Constants.BillingStatus.Cancel === drop?.billingStatus
        )
          ? {
              ...billing,
              isCheck: billing?.value?.dropDetailList?.sort((a, b) => (b?.dropIncome - a?.dropIncome))
                ?.filter(
                  (drop) =>
                    (!drop?.billingStatus &&
                      !drop?.queueDetailList?.every(
                        (q) => !Constants.SuccessQueueStatus.includes(q.qstatus)
                      )) ||
                    Constants.BillingStatus.Cancel === drop?.billingStatus
                )
                ?.every((drop) => drop?.isCheck),
            }
          : billing
      );
    setSearchResult(updatedBilling);
    setIsSelectAll(
      updatedBilling
        ?.slice((page - 1) * pageSize, (page - 1) * pageSize + pageSize)
        ?.filter((bill) =>
          bill?.value?.dropDetailList?.some(
            (item) =>
              (!item.billingStatus &&
                !item?.queueDetailList?.every(
                  (q) => !Constants.SuccessQueueStatus.includes(q.qstatus)
                )) ||
              Constants.BillingStatus.Cancel === item.billingStatus
          )
        )
        ?.every((billing) => billing?.isCheck)
    );
  };

  const handleExpand = (item, countIndex) => {
    const currentIndex = (page - 1) * pageSize + countIndex;
    const updatedBilling = searchResult.map((billing, idx) =>
      idx === currentIndex
        ? { ...billing, isExpand: !billing.isExpand }
        : billing
    );
    setSearchResult(updatedBilling);
  };

  function getDateEven(date, numDate, isPluss) {
    let futureDate = new Date(date);
    futureDate.setDate(
      futureDate.getDate() + (isPluss ? numDate : numDate * -1)
    );
    return futureDate;
  }

  const filterWorker = (group) => {
    const workers = workerList?.filter((item) =>
      group ? item.organzineId === group : true
    );
    let listWorkerOption = workers?.map(function (item) {
      return {
        label: item.workerName,
        value: item.workerNo,
      };
    });
    listWorkerOption = listWorkerOption?.filter((item, index, self) => {
      return self.findIndex((u) => u.value === item.value) === index;
    });

    return listWorkerOption;
  };

  const filterGroup = (worker) => {
    const organizeWorker = worker
      ? workerList?.filter((item) => item.workerNo === worker)
      : null;
    const groups = organizeList?.filter((item) =>
      organizeWorker
        ? organizeWorker.some((x) => x.organzineId === item.organizeID)
        : true
    );
    let listGroupOption = groups?.map(function (item) {
      return {
        label:
          item.organizeID +
          " : " +
          (isTH ? item.organizeNameTH : item.organizeNameEN),
        value: item.organizeID,
      };
    });

    return listGroupOption;
  };

  const getPictureStatusDesc = (status) => {
    switch (status) {
      case Constants.Status.Yes:
        return t("Pass");
      case Constants.Status.No:
        return t("NotPass");
      case Constants.Status.Wait:
        return t("WaitingVerification");
      default:
        return t("NotPass");
    }
  };

  const getAddress = (address) => {
    let result = "";
    if (address) {
      if (address?.village != null) {
        result += `${address.village} `;
      }
      if (address?.floor != null) {
        result += `${t("Floor")} ${address.floor} `;
      }
      if (address?.unit != null) {
        result += `${t("Unit")} ${address.unit} `;
      }
      if (address?.number != null) {
        result += `${t("Number")} ${address.number} `;
      }
      if (address?.soi != null) {
        result += `${t("Soi")} ${address.soi} `;
      }
      if (address?.moo != null) {
        result += `${t("Moo")} ${address.moo} `;
      }
      //   if (building != null && building.isNotEmpty) {
      //     result += '${'text.building'.tr()} $building ';
      //   }

      if (address?.street != null) {
        result += `${t("Street")} ${address.street} `;
      }
      if (address?.subdistrict != null) {
        result += `${t("SubDistrict")} ${address.subdistrict} `;
      }
      if (address?.district != null) {
        result += `${t("District")} ${address.district} `;
      }
      if (address?.province != null) {
        result += `${t("Province")} ${address.province} `;
      }
      if (address?.postcode != null) {
        result += `${address.postcode}`;
      }
    }
    return result;
  };

  const getPictureStatusColor = (status) => {
    switch (status) {
      case Constants.Status.Yes:
        return "success";
      case Constants.Status.No:
        return "error";
      case Constants.Status.Wait:
        return "warning";
      default:
        return "error";
    }
  };

  const getBillingStatusDesc = (status) => {
    let statusDesc =
      statusList?.find((item) => item.configValue === status)?.configDesc ??
      t("NotSummaryBillingStatus");

    return statusDesc;
  };

  useEffect(() => {
    let optionOrganize = organizeList?.map((item) => {
      return {
        label:
          item.organizeID +
          " : " +
          (isTH ? item.organizeNameTH : item.organizeNameEN),
        value: item.organizeID,
      };
    });
    setOptionsOrganize(optionOrganize);
  }, [isTH, organizeList]);

  useEffect(() => {
    setOptionsWorker(filterWorker());
  }, [workerList]);

  useEffect(() => {
    let optionStatus = statusList?.map((item) => {
      return { label: item.configDesc, value: item.configValue };
    });
    setOptionsStatusJob(optionStatus);
    if (
      optionStatus &&
      optionStatus.length > 0 &&
      optionStatus.find((type) => type.value === Constants.BillingStatus.All)
    ) {
      setSelectedBillingStatus(
        optionStatus.filter(
          (type) => type.value === Constants.BillingStatus.All
        )[0]
      );
    }
  }, [statusList]);

  useEffect(() => {
    setSearchResult(null);
    setIsSelectAll(false);
    setStartDeleveryDate(
      getDateEven(new Date(new Date().toDateString()), 30, false)
    );
    setEndDeleveryDate(
      getDateEven(new Date(new Date().toDateString()), 0, false)
    );
    setSelectedGroup(null);
    setSelectedWorker(null);
    setSelectedBillingStatus(null);
  }, [selectedSubNo]);

  return (
    <>
      <div style={{ padding: "0 .5% 1% .5%" }}>
        <Card style={{ padding: "15px", borderWidth: "0px" }}>
          <Row>
            <Col className="TextHead RowDeatail">
              <label>{t("SpecialofBilling")}</label>
            </Col>
          </Row>
          <Row className="RowDeatail">
            <Col xs={4} sm={3} md={1} lg={1} className="TextRight">
              <label>{t("WorkGroup")}</label>
            </Col>
            <Col xs={8} sm={3} md={3} lg={3} className="TextLeft">
              <Dropdown
                id="GroupDropdown"
                value={selectedGroup}
                onChange={(e) => {
                  handleselectGroup(e);
                }}
                width={"100%"}
                options={optionsOrganize}
                placeholder={t("All")}
                isDisabled={false}
                isClearable={true}
              />
            </Col>
            <Col xs={4} sm={3} md={1} lg={1} className="TextRight">
              <label>{t("TechnicianName")} </label>
            </Col>
            <Col xs={8} sm={3} md={3} lg={3} className="TextLeft">
              <Dropdown
                id="TechnicianNameDropdown"
                value={selectedWorker}
                onChange={(e) => {
                  handleselectWorker(e);
                }}
                width={"100%"}
                options={optionsWorker}
                placeholder={t("All")}
                isDisabled={false}
                isClearable={true}
              />
            </Col>
            <Col xs={4} sm={3} md={1} lg={1} className="TextRight">
              <label>{t("BillingStatus")}</label>
            </Col>
            <Col xs={8} sm={3} md={3} lg={3} className="TextLeft">
              <Dropdown
                id="StatusDropdown"
                value={selectedBillingStatus}
                onChange={(e) => {
                  handleselectStatus(e);
                }}
                width={"100%"}
                options={optionsStatusJob}
                placeholder={t("All")}
                isDisabled={false}
                isClearable={true}
              />
            </Col>
          </Row>
          <Row className="RowDeatail">
            <Col xs={2} sm={2} md={2} lg={1} className="TextRight">
              <label style={{ fontSize: "14px", color: "red" }}>{`*`}</label>
              <label>{t("DeliveryDate")}</label>
            </Col>
            <Col xs={4} sm={4} md={3} lg={3} className="TextRight">
              <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={startDeleveryDate}
                minDate={getDateEven(new Date(), 365, false)}
                maxDate={getDateEven(new Date(), -365, false)}
                onChange={(date) => handleselectStartDeliveryDate(date)}
              />
            </Col>
            <Col xs={1} sm={1} md={1} lg={1} className="TextCenter">
              <label>-</label>
            </Col>
            <Col xs={4} sm={4} md={3} lg={3} className="TextRight">
              <DatePicker
                dateFormat="dd/MM/yyyy"
                selected={endDeleveryDate}
                minDate={startDeleveryDate}
                maxDate={getDateEven(startDeleveryDate, 30, true)}
                onChange={(date) => handleselectEndDeliveryDate(date)}
              />
            </Col>
          </Row>
          <Row className="RowDeatail">
            <Col xs={2} sm={2} md={2} lg={1} className="TextRight"></Col>
            <Col
              xs={10}
              sm={10}
              md={10}
              lg={11}
              className="TextLeft TextWarning"
            >
              <div>
                <div>
                  <label>( {t("RemarkSelectDeliveryDate")} )</label>
                </div>
                <div>
                  <label>* {t("RemarkSpecialofBilling")}</label>
                </div>
              </div>
            </Col>
          </Row>
          <div className="ConTentRight">
            <div style={{ paddingRight: "15px" }}>
              <Button
                className={
                  !searchResult ||
                  searchResult.length === 0 ||
                  searchResult?.every((billing) => billing?.value?.dropDetailList?.every(dropDetail => !dropDetail?.isCheck ?? true))
                    ? "disabledCancelButton"
                    : "buttonRequestSpecialRounds"
                }
                style={{ width: "180px", position: "relative" }}
                icon={
                  <CurrencyExchange
                    style={{
                      position: "absolute",
                      top: "5px",
                      left: "10px",
                      height: "20px",
                      width: "20px",
                    }}
                  />
                }
                disabled={
                  !searchResult ||
                  searchResult.length === 0 ||
                  searchResult?.every((billing) => billing?.value?.dropDetailList?.every(dropDetail => !dropDetail?.isCheck ?? true))
                }
                title={t("RequestSpecialRounds")}
                onClick={onClickRequestSpecialRounds}
              />
            </div>
            <div style={{ paddingRight: "5px" }}>
              <Button
                style={{ width: "120px", position: "relative" }}
                title={t("Search")}
                icon={
                  <Search
                    style={{
                      position: "absolute",
                      top: "6px",
                      right: "10px",
                      height: "25px",
                      width: "25px",
                    }}
                  />
                }
                onClick={() => onSearchBilling(pageSize)}
              />
            </div>
          </div>
        </Card>

        <Card
          style={{ padding: "15px", marginTop: "15px", borderWidth: "0px" }}
        >
          <Row>
            <Col className="TextHead RowDeatail">
              <label>{t("SearchResult")}</label>
            </Col>
          </Row>
          <Row>
            <div style={{ marginLeft: "1px", marginRight: "5px" }}>
              <table
                className="TableBill"
                style={{ width: "100%", marginTop: "10px" }}
              >
                <thead>
                  <tr
                    style={{
                      background: "#1976d2",
                      height: "50px",
                      color: "white",
                    }}
                  >
                    <th></th>
                    <th className={isSelectAll ? "checked" : ""}>
                      <Input
                        type="checkbox"
                        checked={isSelectAll}
                        onChange={(e) => {
                          handleCheckSelectAll(e);
                        }}
                        className={isSelectAll ? "blue-checkbox-input" : ""}
                        style={{
                          width: "20px",
                          height: "20px",
                          backgroundColor: isSelectAll ? "white" : "",
                        }}
                        disabled={
                          !searchResult ||
                          searchResult?.length === 0 ||
                          searchResult
                            ?.slice(
                              (page - 1) * pageSize,
                              Math.min(page * pageSize, searchResult?.length)
                            )
                            ?.filter((bill) =>
                              bill?.value?.dropDetailList?.some(
                                (item) => !item?.billingStatus
                              )
                            )?.length === 0
                        }
                      />
                    </th>
                    <th>{t("DeliveryDate")}</th>
                    <th>{t("TechnicianName")}</th>
                    <th>{t("WorkGroup")}</th>
                    <th>{t("TotalIncome")}</th>
                    <th>{t("SpecialRound")}</th>
                    <th>{t("ProcessingFee")}</th>
                    <th>{t("EstimatedIncome")}</th>
                  </tr>
                </thead>
                <tbody>
                  {searchResult
                    ?.slice(
                      (page - 1) * pageSize,
                      Math.min(page * pageSize, searchResult?.length)
                    )
                    ?.map((item, index) => {
                      return (
                        <Fragment>
                          <tr
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#E4EEFF" : "white",
                              height: "40px",
                            }}
                          >
                            <td style={{ width: "5%" }} className="boaderTop">
                              {item?.isExpand ? (
                                <KeyboardArrowDown
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleExpand(item, index)}
                                />
                              ) : (
                                <KeyboardArrowRight
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleExpand(item, index)}
                                />
                              )}
                            </td>
                            <td className="boaderTop">
                              <Input
                                type="checkbox"
                                checked={item?.isCheck ?? false}
                                onChange={(e) => {
                                  handleCheckSelectBilling(e, index);
                                }}
                                disabled={item?.value?.dropDetailList?.every(
                                  (billing) =>
                                    (billing?.billingStatus && Constants.BillingStatus.Cancel !== billing?.billingStatus) ||
                                    (!billing?.billingStatus &&
                                      !billing?.queueDetailList?.every((q) => q?.qstatus === Constants.QueueStatus.Success 
                                      ))
                                ) || item?.value?.totalIncome == 0}
                                className={
                                  item?.isCheck ?? false
                                    ? "blue-checkbox-input"
                                    : ""
                                }
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  backgroundColor:
                                    item?.isCheck ?? false ? "white" : "",
                                }}
                              />
                            </td>
                            <td className="boaderTop">
                              {DateUtil.ConvertDatetoFormatdateNormal(
                                item?.value?.deliveryDate
                              )}
                            </td>
                            <td className="boaderTop">
                              {item?.value?.workerName}
                            </td>
                            <td className="boaderTop">
                              {isTH
                                ? item?.value?.organizeDescTH
                                : item?.organizeDescEN}
                            </td>
                            <td className="boaderTop">
                              {Number(item?.value?.totalIncome)
                                .toFixed(2)
                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                            </td>
                            <td className="boaderTop">
                              {Number(item?.value?.specialBilling)
                                .toFixed(2)
                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                            </td>
                            <td className="boaderTop">
                              {Number(item?.value?.tradeDiscount)
                                .toFixed(2)
                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                            </td>
                            <td className="boaderTop">
                              {Number(item?.value?.estimateIncome)
                                .toFixed(2)
                                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                            </td>
                          </tr>
                          {item?.isExpand && (
                            <tr
                              style={{
                                backgroundColor:
                                  index % 2 === 0 ? "#E4EEFF" : "white",
                              }}
                            >
                              <td colSpan={9}>
                                <div
                                  style={{
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {item?.value?.dropDetailList?.sort((a, b) => (b?.dropIncome - a?.dropIncome))?.map(
                                    (list, inD) => {
                                      return (
                                        <>
                                          <Row
                                            className="RowDeatail"
                                            style={{ marginBottom: "5px" }}
                                          >
                                            <Col
                                              xs={2}
                                              sm={2}
                                              md={2}
                                              lg={2}
                                              className="TextRight"
                                              
                                            >{  list.queueDetailList.every((item) => item?.qstatus === Constants.QueueStatus.Success 
                                              && item?.pictureStatus === Constants.Status.Yes) && Number(list?.dropIncome) !== 0 && (
                                              <Input
                                                type="checkbox"
                                                checked={list?.isCheck ?? false}
                                                onChange={(e) => {
                                                  handleCheckSelectDrop(
                                                    e,
                                                    index,
                                                    inD
                                                  );
                                                }}
                                                hidden={
                                                  (list?.billingStatus &&
                                                    Constants.BillingStatus
                                                      .Cancel !==
                                                      list?.billingStatus) ||
                                                  (!list?.billingStatus &&
                                                    list?.queueDetailList?.every(
                                                      (q) =>
                                                        !Constants.SuccessQueueStatus.includes(
                                                          q.qstatus
                                                        )
                                                    ))
                                                }
                                                className={
                                                  list?.isCheck ?? false
                                                    ? "blue-checkbox-input"
                                                    : ""
                                                }
                                                style={{
                                                  width: "20px",
                                                  height: "20px",
                                                  backgroundColor:
                                                    list?.isCheck ?? false
                                                      ? "white"
                                                      : "",
                                                }}
                                              />)
                                              }
                                              <label
                                                style={{ paddingLeft: "3px" }}
                                              >
                                                {t("Customer")} :{" "}
                                              </label>
                                            </Col>
                                            <Col
                                              xs={2}
                                              sm={2}
                                              md={2}
                                              lg={2}
                                              className="TextLeft"
                                            >
                                              <label>{list.shiptoName}</label>
                                            </Col>
                                            <Col
                                              xs={2}
                                              sm={2}
                                              md={2}
                                              lg={2}
                                              className="TextRight"
                                            >
                                              <label>{t("Income")} : </label>
                                            </Col>
                                            <Col
                                              xs={1}
                                              sm={1}
                                              md={1}
                                              lg={1}
                                              className="TextLeft"
                                            >
                                              <label>
                                                {Number(list?.dropIncome)
                                                  .toFixed(2)
                                                  .replace(
                                                    /\d(?=(\d{3})+\.)/g,
                                                    "$&,"
                                                  )}
                                              </label>
                                            </Col>
                                            <Col xs={2} sm={2} md={2} lg={2}>
                                              <Button
                                                style={{
                                                  width: "120px",
                                                  minHeight: "24px",
                                                }}
                                                title={t("Detail")}
                                                onClick={() =>
                                                  onClickViewQueueDetail(
                                                    item?.value?.deliveryDate,
                                                    item?.value?.workerNo,
                                                    list.shiptoNo
                                                  )
                                                }
                                              />
                                            </Col>
                                            <Col
                                              xs={1}
                                              sm={1}
                                              md={1}
                                              lg={1}
                                              className="TextRight"
                                            >
                                              <label>{t("Status")} : </label>
                                            </Col>
                                            <Col
                                              xs={2}
                                              sm={2}
                                              md={2}
                                              lg={2}
                                              className="TextLeft"
                                              style={{ fontWeight: "bold" }}
                                            >
                                              <label>
                                                {getBillingStatusDesc(
                                                  list.billingStatus
                                                )}
                                              </label>
                                            </Col>
                                          </Row>
                                          <Row className="RowDeatail">
                                            <Col
                                              xs={4}
                                              sm={3}
                                              md={2}
                                              lg={2}
                                              className="TextRight"
                                            >
                                              <label>{t("Address")} : </label>
                                            </Col>
                                            <Col
                                              xs={8}
                                              sm={9}
                                              md={10}
                                              lg={10}
                                              className="TextLeft"
                                            >
                                              <label>
                                                {getAddress(list?.address)}
                                              </label>
                                            </Col>
                                          </Row>
                                          <Row>
                                            {list.queueDetailList &&
                                              list.queueDetailList.length >
                                                0 && (
                                                <Card
                                                  style={{
                                                    width: "60%",
                                                    marginRight: "auto",
                                                    marginLeft: "auto",
                                                    marginBottom: "20px",
                                                    backgroundColor:
                                                      "rgba(192,192,200, 0.6)",
                                                    borderWidth: "0px",
                                                  }}
                                                >
                                                  <table>
                                                    <tbody>
                                                      {list.queueDetailList?.map(
                                                        (queue, queueIndex) => {
                                                          return (
                                                            <tr
                                                              style={{
                                                                height: "24px",
                                                              }}
                                                            >
                                                              <td>
                                                                <label>
                                                                  {t("QueueNo")}{" "}
                                                                  : {queue.qno}
                                                                </label>
                                                              </td>
                                                              <td>
                                                                <label>
                                                                  {t(
                                                                    "QueueStatus"
                                                                  )}{" "}
                                                                  :{" "}
                                                                  {
                                                                    queue.qstatus
                                                                  }
                                                                </label>
                                                              </td>
                                                              <td>
                                                                <label>
                                                                  {t(
                                                                    "PhotoStatus"
                                                                  )}{" "}
                                                                  :{" "}
                                                                  {getPictureStatusDesc(
                                                                    queue.pictureStatus
                                                                  )}
                                                                </label>
                                                                <PhotoCameraOutlined
                                                                  color={getPictureStatusColor(
                                                                    queue.pictureStatus
                                                                  )}
                                                                  style={{
                                                                    paddingLeft:
                                                                      "3px",
                                                                  }}
                                                                ></PhotoCameraOutlined>
                                                              </td>
                                                            </tr>
                                                          );
                                                        }
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </Card>
                                              )}
                                          </Row>
                                        </>
                                      );
                                    }
                                  )}
                                </div>
                              </td>
                            </tr>
                          )}
                        </Fragment>
                      );
                    })}
                </tbody>
              </table>
              <div style={{ position: "relative", left: "12px" }}>
                <CustomPagination
                  page={page}
                  pageSize={pageSize}
                  pageCount={pageCount}
                  onPageChange={handlePageChange}
                  rowsPerPageOptions={[5, 10, 25]}
                  onPageSizeChange={(newPageSize) =>
                    onSearchBilling(newPageSize)
                  }
                />
              </div>
            </div>
          </Row>
        </Card>
      </div>
      <ModalComponent
        className="custom-modal"
        id="openQueueDetailModal"
        isOpen={isOpenModalQueueDetail}
        onClose={() => setIsOpenModalQueueDetail(false)}
        size={"xl"}
        title={
          <span className="TextLeft TextHead">{`${t("QueueDetail")} ${t(
            "workingDate",
            {
              date: DateUtil.ConvertDatetoFormatdateNormal(
                queueDetail?.deliveryDate
              ),
            }
          )}`}</span>
        }
      >
        {
          <div
            style={{
              height: "100%",
              width: "100",
              padding: "0px 20px 20px 20px",
              display: "flex",
              flexDirection: "column",
              gap: "15px",
            }}
          >
            <Row>
              <Col className="TextLeft">
                <label>{t("Customer")} : </label>{" "}
                <label>{queueDetail?.shiptoName}</label>
              </Col>
            </Row>
            <Row>
              <Col className="TextLeft">
                <label>{t("Address")} : </label>{" "}
                <label>{getAddress(queueDetail?.address)}</label>
              </Col>
            </Row>
            <Row>
              <Col className="TextLeft">
                <label>{t("EstimatedIncome")} : </label>{" "}
                <label>
                  {Number(queueDetail?.totalPrice)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                </label>
              </Col>
            </Row>
            <div
              style={{
                maxHeight: "400px",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                gap: "15px",
              }}
            >
              {queueDetail.queueDetailList?.map((queue, indexQueue) => {
                return (
                  <>
                    <Row>
                      <Col
                        xs={6}
                        sm={6}
                        md={4}
                        lg={4}
                        className="TextLeft"
                        style={{ fontWeight: "bold" }}
                      >
                        <label>
                          {t("QueueNo")} : {queue?.qNo}
                        </label>
                      </Col>
                      <Col
                        xs={6}
                        sm={6}
                        md={4}
                        lg={4}
                        className="TextLeft"
                        style={{ fontWeight: "bold" }}
                      >
                        <label>
                          {t("QueueStatus")} : {queue?.qStatus}
                        </label>
                      </Col>
                      <Col
                        xs={6}
                        sm={6}
                        md={4}
                        lg={4}
                        className="TextRight"
                        style={{ fontWeight: "bold" }}
                      >
                        <label>
                          {t("PhotoStatus")} :{" "}
                          {getPictureStatusDesc(queue?.pictureStatus)}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={6}
                        sm={6}
                        md={6}
                        lg={6}
                        className="TextLeft"
                        style={{ fontWeight: "bold", color: "red" }}
                      >
                        <label hidden={!queueDetail.advNo || 'N' === queueDetail.billingTypeStatus}>
                          {t("BillingType")} : {t("Special")}
                        </label>
                      </Col>
                      <Col
                        xs={6}
                        sm={6}
                        md={6}
                        lg={6}
                        className="TextRight"
                        style={{ fontWeight: "bold", color: "green" }}
                      >
                        <label>
                          {t("EstimatedIncome")} :{" "}
                          {Number(queue?.queuePrice)
                            .toFixed(2)
                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                        </label>
                      </Col>
                    </Row>

                    {queue?.productDetail &&
                      queue?.productDetail.length > 0 && (
                        <table
                          style={{
                            width: "100%",
                            marginTop: "10px",
                            textAlign: "center",
                          }}
                        >
                          <thead>
                            <tr
                              style={{
                                background: "#1976d2",
                                color: "white",
                                height: "40px",
                              }}
                            >
                              <th>{t("ProductList")}</th>
                              <th>{t("SuccessesNumber")}</th>
                              <th>{t("TotalNumber")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {queue?.productDetail?.map(
                              (product, indexproduct) => {
                                return (
                                  <tr
                                    style={{
                                      backgroundColor:
                                        indexproduct % 2 === 0
                                          ? "#E4EEFF"
                                          : "white",
                                      height: "40px",
                                    }}
                                  >
                                    <td
                                      style={{
                                        textAlign: "left",
                                        paddingLeft: "10px",
                                      }}
                                    >
                                      <label>{product?.productName}</label>
                                    </td>
                                    <td>
                                      <label>
                                        {product?.totalSuccess}
                                        {product?.unit
                                          ? ` ${product?.unit}`
                                          : ""}
                                      </label>
                                    </td>
                                    <td>
                                      <label>
                                        {product?.total}
                                        {product?.unit
                                          ? ` ${product?.unit}`
                                          : ""}
                                      </label>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </table>
                      )}
                  </>
                );
              })}
            </div>
          </div>
        }
      </ModalComponent>
    </>
  );
}

export default RequestSpecialBilling;
